import React from 'react';
import { Link } from 'react-router-dom';
import { CloudyIcon } from 'lucide-react';
export function Logo() {
  return <Link to="/" className="group flex items-center gap-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" aria-label="Kévin AutoVap — accueil" data-id="element-153" data-mp="8tv393au9uka">
      <span className="grid h-10 w-10 place-items-center rounded-xl bg-lime text-ink" data-id="element-154" data-mp="3v84lsvs388d5">
        <CloudyIcon className="h-5 w-5" strokeWidth={2.25} aria-hidden="true" data-id="element-155" data-mp="mt4856tlh28y" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-156" data-mp="rrp7l410vhwc">
        <span className="font-display text-lg font-bold tracking-tight text-white" data-id="element-157" data-mp="rrfhlgfz9aqn">
          Kévin<span className="text-lime" data-id="element-158" data-mp="dregq0zpq3b6">AutoVap</span>
        </span>
        <span className="mt-1 text-[11px] text-fog" data-id="element-159" data-mp="ht8d3x2vkl5j">Nettoyage vapeur à domicile</span>
      </span>
    </Link>;
}